
import React from "react";

import CleanUpDisk from "../component/CleanUpDisk";

const CleanUpDiskContainer = ({ pageId }) => (<CleanUpDisk pageId={pageId} />)

export default CleanUpDiskContainer; 